import { render, staticRenderFns } from "./detail-component-exchange-steps.vue?vue&type=template&id=76199d34&scoped=true"
import script from "./detail-component-exchange-steps.vue?vue&type=script&lang=ts"
export * from "./detail-component-exchange-steps.vue?vue&type=script&lang=ts"
import style0 from "./detail-component-exchange-steps.vue?vue&type=style&index=0&id=76199d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76199d34",
  null
  
)

export default component.exports